import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSocialLogin } from "../../helpers/firebaseAuth";
import { useAuthStatus } from "../../hooks/useAuthStatus";

export function useLoginState() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithGoogle } = useSocialLogin();
  const { checkAuth } = useAuthStatus();

  const returnUrl = searchParams.get("returnUrl");
  const mode = searchParams.get("mode"); // "pm" | "tenant" — which dashboard the user picked before signing in
  const reason = searchParams.get("reason"); // e.g. "session-expired" — set by apiFetch's forced sign-out

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(
    reason === "session-expired" ? "Your session expired. Please sign in again." : ""
  );

  return {
    navigate,
    loginWithGoogle,
    checkAuth,
    returnUrl,
    mode,
    loading,
    setLoading,
    error,
    setError,
  };
}
